import { BUNDLE, getProductById, type CatalogId } from "@/lib/products";
import type { Language } from "@/lib/translations";

/** Read-only view of a catalog entry for the shop pages (derived, no new data). */
export function getShopView(id: CatalogId, language: Language, bundleDescription: string) {
  if (id === "bundle") {
    return { id, name: BUNDLE.name[language], description: bundleDescription, price: BUNDLE.price, image: BUNDLE.image };
  }
  const p = getProductById(id);
  if (!p) return undefined;
  return { id, name: p.name[language], description: p.description[language], price: p.price, image: p.image };
}

export const formatPriceEur = (value: number, language: Language) =>
  new Intl.NumberFormat(language === "en" ? "en-IE" : language === "pt" ? "pt-PT" : "de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(value);

/** Legally required unit price (€/kg) from PRODUCT_PAGE_CONTENT; null when net quantity is unknown. */
export const getUnitPrice = (price: number, netQuantityKg: number | null, language: Language) =>
  netQuantityKg ? formatPriceEur(price / netQuantityKg, language) : null;
